

















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, Pdi, VehicleLocation } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { IDialogOption } from '@/models/dialog';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class SaveStoreVehicleLocationPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};

  public terminalModel: any = {
    id: '',
    locationName: '',
    friendlyName: '',
  };
  public selectedLocation: string = '';
  public form: any = {};
  public devicePairLocationFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;
  public deviceCode = '';
  public locationName = '';

  public showSelectStorePopup: IDialogOption = {
    width: 600,
    title: 'Terminal Device',
    model: false,
    loading: false,
    close: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('switchStoreDialog.btnText') as string,
    },
    onClose: (): void => {
      this.onClose();
    },
  };

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'SquareAccount' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(
          false,
          this.$t('stores.vehicleLocations.alertInvalidForm')
        );
        this.resetMethodName(methodName);
        return;
      }
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setLocationFields();
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setLocationFields(): void {
    this.devicePairLocationFields = [
      {
        key: 'locationName',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: true,
          required: false,
          label: 'Location Name',
          counter: 30,
          loading: false,
          rules:[
            v => this.required('Location Name',v)
          ]
        },
      },
      {
        key: 'friendlyName',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: 'Device Friendly Name',
          counter: 30,
          loading: false,
          rules:[
            v => this.required('Device Friendly Name',v)
          ]
        },
      },
    ];
  }

  public onClose() {
    this.$router
      .push({
        name: 'admin.stores.edit',
        params: {
          tenantId: this.tenantId.toString(),
          enterpriseId: this.enterpriseId.toString(),
          storeId: this.storeId.toString(),
          tab:'SquareAccount'
        },
      })
      .catch((ex) => {
        console.log(ex);
      });
  }

  public validateDevicePair(): Vue & { validate: () => boolean } {
    return this.$refs.devicePairForm as Vue & { validate: () => boolean };
  }

  public async saveDevicePairCode(): Promise<void> {
    if(this.validateDevicePair().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (
          this.terminalModel.friendlyName == undefined ||
          this.terminalModel.friendlyName == ''
        ) {
          this.showAlert(false, 'Please Add Friendly Name');
          return;
        }
        const res = await storeService.getDevicePairCode(
          this.terminalModel.id,
          this.terminalModel.friendlyName,
          this.storeId.toString()
        );
        if (res.deviceCode != '') {
          this.deviceCode = res.deviceCode;
          this.showSelectStorePopup.model = true;
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.devicePairLocationFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.storeJson = this.storeViewModel.storeJson;
      this.terminalModel.id = this.storeViewModel.storeJson.squareLocationId;
      const locations = [];
      const terminalLocationResponse = await storeService.getTerminalLocation(
        this.storeId.toString(),
        true
      );
      locations.push(terminalLocationResponse);
      this.terminalModel.locationName = locations[0].filter(
        (x) => x.id == this.terminalModel.id
      );
      this.terminalModel = {
        id: this.terminalModel.id,
        locationName: this.terminalModel.locationName[0].name,
      };
    } finally {
      this.formlyHideSkeleton(this.devicePairLocationFields);
    }
  }
}
